// src/pages/ProductPage/ProductPage.js

import React, { useEffect, useState } from 'react';
import { Layout, Spin, Row, Col, Select, Typography } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import ProductCard from './productCard'; // Ensure correct path
import { useAuth } from '../../context/DBContext';  // Use Firebase functions from DBContext

const { Content } = Layout;
const { Option } = Select;
const { Title } = Typography;

const ProductPage = () => {
    const { fetchProducts } = useAuth();  // Fetch products from Firebase
    const [products, setProducts] = useState([]);
    const [filteredProducts, setFilteredProducts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selectedCategory, setSelectedCategory] = useState(null);

    useEffect(() => {
        const loadProducts = async () => {
            try {
                const fetchedProducts = await fetchProducts();  // Fetch products from Firebase
                setProducts(fetchedProducts);  // Set products in state
                setFilteredProducts(fetchedProducts);
                setLoading(false);
            } catch (error) {
                // console.error("Error loading products:", error);
                setLoading(false);
            }
        };
        loadProducts();
    }, [fetchProducts]);

    const handleCategoryChange = (value) => {
        setSelectedCategory(value);
        filterProducts(value);
    };

    const filterProducts = (category) => {
        if (category) {
            const filtered = products.filter(product => product.category === category);
            setFilteredProducts(filtered);
        } else {
            setFilteredProducts(products);
        }
    };

    // Extract unique categories for the filter dropdown
    const categories = [...new Set(products.map(product => product.category))];

    return (
        <Layout>
            <Content style={{ padding: '20px' }}>
                <Row justify="space-between" align="middle" style={{ marginBottom: '20px' }}>
                    <Col>
                        <Title level={3}>
                            Products 
                        </Title>
                    </Col>
                </Row>

                <Row gutter={[16, 16]} style={{ marginBottom: '20px' }}>
                    <Col xs={24} sm={12} md={8}>
                        <Select
                            placeholder="Filter by Category"
                            allowClear
                            style={{ width: '100%' }}
                            onChange={handleCategoryChange}
                            value={selectedCategory}
                        >
                            {categories.map(category => (
                                <Option key={category} value={category}>{category}</Option>
                            ))}
                        </Select>
                    </Col>
                </Row>

                {loading ? (
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50vh' }}>
                        <Spin indicator={<LoadingOutlined style={{ fontSize: 48 }} spin />} />
                    </div>
                ) : (
                    <Row gutter={[16, 16]}>
                        {filteredProducts.map((product) => (
                            <Col 
                                key={product.id} 
                                xs={24} sm={12} md={8} // Ensures 3 cards per row on md screens
                                style={{ display: 'flex' }}
                            >
                                <ProductCard
                                    productId={product.id} // Pass productId for fetching reviews
                                    productName={product.name}
                                    description={product.description}
                                    categories={[product.category]}  // Categories from Firebase
                                    imageUrl={product.image}  // Use 'product.image' like in AdminProductPage
                                    productLink={product.link}  // Link from Firebase
                                />
                            </Col>
                        ))}
                    </Row>
                )}
            </Content>
        </Layout>
    );
};

export default ProductPage;
